// extracted by mini-css-extract-plugin
export default {"fullscreenDialogPageContainer":"fullscreen-dialog_fullscreenDialogPageContainer__zMImd","content":"fullscreen-dialog_content__J8hbd"};